import React, { useEffect, useState } from "react";
import { getDeviceType, isIOS } from "lib/deviceInfo";
import InstallGuideForIOS from "container/snackbar/InstallGuideForIOS";
import PWAInstallPromptForAndroid from "container/snackbar/PWAInstallPromptForAndroid";
import PropTypes from "prop-types";

PWAGuideSnackbar.propTypes = {
  readyToShow: PropTypes.bool.isRequired
};

function PWAGuideSnackbar(props) {
  const { readyToShow } = props;
  const [isAppleMobile, setIsAppleMobile] = useState(false);
  const [isAnotherMobile, setIsAnotherMobile] = useState(false);

  useEffect(() => {
    initSnackbar();
  }, []);

  const initSnackbar = () => {
    if (getDeviceType() !== "mobile") {
      return null;
    } else if (isIOS) {
      setIsAppleMobile(true);
    } else {
      setIsAnotherMobile(true);
    }
  };

  return (
    <div>
      {isAppleMobile && <InstallGuideForIOS readyToShow={readyToShow} />}
      {isAnotherMobile && (
        <PWAInstallPromptForAndroid readyToShow={readyToShow} />
      )}
    </div>
  );
}

export default PWAGuideSnackbar;
